import { useEffect, useState } from "react";
import "./App.css";
import Loader from "./components/Loader";
import logo from "./assets/logo.png";
import MainContent from "./components/MainContent";

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 5000);
    }, []);

    return (
        <div className="App">
            <MainContent />
            {loading ? (
                <Loader
                    label1="Welcome to Our Website • Loading Content • Please Wait •"
                    label2="Experience Begins Soon • Sit Back • Stay Tuned •"
                    logoSrc={logo}
                />
            ) : (
                <></>
            )}
        </div>
    );
}

export default App;
